import * as React from "react";
import { IlluSection } from "./IlluSections";

export default () => {
  return (
    <svg version="1.1" id="HG" x="0px" y="0px" viewBox="0 0 2383.9 1683.8">
      <g id={IlluSection.performance}>
        <path
          fill="#F5F5F5"
          d="M1981.2,1627.7l-123.8-478.9c-1.5-6-5-11.2-9.9-15c0,0-257.7-200.6-292.1-227.4c-2.4-1.8-5.4-2.6-8.3-2
                c-31.6,6.1-63.8,7.4-95.8,4c-2.9-0.3-5.8,1.1-7.4,3.5c-16.9,25.8-107.2,165.4-107.2,165.4c-5.5,8.5-7.2,18.8-4.7,28.6l153.2,602.7
                l483.6-62.3c8.1-1.1,13.9-8.5,12.8-16.6C1981.5,1628.9,1981.3,1628.3,1981.2,1627.7L1981.2,1627.7z"
        />
      </g>
      <g id={IlluSection.solutions}>
        <path
          fill="#F5F5F5"
          d="M1950.7,455l-646,87.9c-26.6,3.6-35.9,37.4-14.9,54.1l122,97.3c2.1,1.7,4.8,2.3,7.5,1.7
                c11.9-4.5,24.3-7.5,36.9-8.7c14.4-1.4,28.9-0.9,43.2,1.5c44.3,1.6,87.8,12.2,121.7,31.8c7.8,4.4,15.1,9.5,22,15.2
                c1.4,1.2,3.2,1.7,5,1.4l135-18.3c6.9-0.9,13.1-4.8,17-10.6L1960,470c3-4.4,1.8-10.4-2.6-13.4C1955.4,455.2,1953,454.7,1950.7,455z"
        />
      </g>
      <g id={IlluSection.refereeTechnologies}>
        <path
          fill="#F5F5F5"
          d="M2070.5,1630.4l475.7-61.2L2420,1068c-1.8-7.3-8.9-12.1-16.4-11.2l-460.7,59c-7.8,1-13.3,8.2-12.3,16
                c0.1,0.6,0.2,1.1,0.3,1.6l122,484.9C2054.9,1626.3,2062.4,1631.4,2070.5,1630.4L2070.5,1630.4z"
        />
      </g>
      <g id={IlluSection.innovation}>
        <path
          fill="#F5F5F5"
          d="M2437.4,403c-1.8-7.1-8.6-11.7-15.8-10.7l-349.9,46.3c-7.4,1-14,5.1-18.2,11.3l-218.8,325.2
                c-3.2,4.8-8.3,8-14.1,8.7l-138.8,18.4c-2.9,0.4-5.3,2.6-5.7,5.6c-3.2,21.2-16.9,41.8-41.2,59.1c-1.6,1.1-2,3.3-0.8,4.9
                c0.2,0.3,0.4,0.5,0.7,0.7l241.9,187.6c6.3,4.9,14.3,7,22.2,5.9l682-92.4L2437.4,403z"
        />
      </g>
      <g id={IlluSection.storytelling}>
        <path
          fill="#F5F5F5"
          d="M2385.1-84.4L1099.3,90.8c-6.8,0.9-11.5,7.1-10.6,13.9c0.1,0.5,0.2,0.9,0.3,1.4l98.2,385.6
                c2,7.9,9.6,13,17.7,11.9l1255.8-171.1c14-1.9,23.7-14.7,21.8-28.7c-0.1-0.9-0.3-1.9-0.5-2.8L2385.1-84.4z"
        />
      </g>
    </svg>
  );
};



// WEBPACK FOOTER //
// ./src/IlluBackground.tsx